import React, { Fragment } from "react";
import { Card, CardBody } from "reactstrap";
import Profile from "../../assest/image/noimage.jpg";
const ImagePreview = (props) => {
  const noImage = ["", null, undefined, "none"];
  const { style, src } = props;
  let image = noImage.includes(src) ? Profile : src;
  return (
    <Fragment>
      <a href={image} target="blank">
        <img alt={props.alt} className="no-preview" style={style} src={image} />
      </a>
    </Fragment>
  );
};
ImagePreview.defaultProps = {
  src: "",
  style: {},
};

export default ImagePreview;
